export class PubSubLogic {
    subscriptionDictionary: { [key: string]: ((...args: any[]) => void)[] }; 

    constructor() {
        this.subscriptionDictionary = {};
    }

    public async subscribe(subscriptionName: string, handler: (...args: any[]) => void) {
        if(!(subscriptionName in this.subscriptionDictionary)) {
            this.subscriptionDictionary[subscriptionName] = [];
        }

        this.subscriptionDictionary[subscriptionName].push(handler);    
    }

    // TODO: Fix 
    public async unsubcribe(subscriptionName: string) {
        if(!(subscriptionName in this.subscriptionDictionary)) {
            return;
        }

        delete this.subscriptionDictionary[subscriptionName];
    }

    public async publish(subscriptionName: string, ...args: any) {
        if(!(subscriptionName in this.subscriptionDictionary)) {
            return;
        }

        let waitingFunctions = this.subscriptionDictionary[subscriptionName];
        for(const waitingFunction of waitingFunctions) {
            waitingFunction(args);
        }
    }
}

export const PubSubLogicSingleton = new PubSubLogic();